module.exports = __webpack_public_path__ + "img/recommend-character.9b4e7bbd.svg";